import { useEffect } from 'react';
import { useLocalStorage } from '../../../device/useStorage';
import appConstants from '../../../../constants';

export default function useRecentSearches(searchCriteria, selectedCriteriaSelectionForm, isSearchRestorationInProgress) {

  const [recentSearches, setRecentSearches] = useLocalStorage(appConstants.LOCALSTORAGE_KEY_RECENT_SEARCHES, []);

  useEffect(
    () => {
      const doesSearchCriteriaHaveRole = searchCriteria.filter(sc=>sc[appConstants.KEY_TYPE] === appConstants.VALUE_PARTNER_ROLE).length > 0;
      if (
        (selectedCriteriaSelectionForm === appConstants.SEARCH_FORM_SEARCH_BY_COMBINED_CRITERIA) &&
        !isSearchRestorationInProgress &&
        !doesSearchCriteriaHaveRole &&
        !!searchCriteria.length
      ) {
        if (recentSearches.length < appConstants.RECENT_SEARCHES_MAX_ITEM_COUNT_LIMIT) {
          setRecentSearches(previousValue => [{ searchCriteria: searchCriteria, searchOrigin: selectedCriteriaSelectionForm }, ...recentSearches]);
        }
        else {
          let reducedRecentSearches = [...recentSearches];
          reducedRecentSearches.pop();
          setRecentSearches(previousValue => [{ searchCriteria: searchCriteria, searchOrigin: selectedCriteriaSelectionForm }, ...reducedRecentSearches]);
        }
      }

    },
    [
      searchCriteria,
      selectedCriteriaSelectionForm,
      isSearchRestorationInProgress
    ]
  );

  return { recentSearches }
}
